import Grid from '@mui/material/Grid';
import Card from 'modules/components/common/card/card';
import Loading from 'modules/components/common/loading/loading';
import BackToTopButtonModal from 'modules/components/common/button/back-to-top-modal';
import { useMediaQuery } from 'hooks/useMediaQuery';
import { useHypoList } from 'modules/report/hooks/useHypo';
import { destructureDataForModalCards } from 'modules/report/utils/data-structure-logbook';

export function ListHypo(props) {
  const isDesktop = useMediaQuery('(min-width: 1024px)');
  const { daysAgo, patientId, topModalRef } = props;
  const { data, isLoading, customDateListLoading, customDateListData } =
    useHypoList({ patientId, daysAgo });

  const listData = typeof daysAgo === 'number' ? data : customDateListData;
  const listLoading =
    typeof daysAgo === 'number' ? isLoading : customDateListLoading;

  return (
    <>
      {listLoading ? (
        <Loading size={'60px'} mt="30px" />
      ) : (
        <Grid container>
          {listData?.map((glucoseCard, index) => {
            const destructureData = destructureDataForModalCards(glucoseCard);
            return (
              <Grid container justifyContent="center" key={index}>
                <Grid item xs={isDesktop ? 9 : 11} mb="16px">
                  <Card cardData={destructureData} />
                </Grid>
              </Grid>
            );
          })}
          {data?.length > 6 && (
            <BackToTopButtonModal topModalRef={topModalRef} />
          )}
        </Grid>
      )}
    </>
  );
}
